import styled from 'styled-components';
import { LineHeightProps, variant } from 'styled-system';
import { Box } from '../Box/Box';
import { Theme } from '../../../theme/theme';
import { ColorProps, LayoutProps, PaddingProps, TypographyProps } from '../../../theme/styledProps';

export type BadgeVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'warning'
  | 'error'
  | 'success'
  | 'notification';

export type BadgeSize = 'small' | 'large' | 'huge';

interface StyledBadge {
  theme: Theme;
  variant: BadgeVariant;
  size: BadgeSize;
}

export const StyledBadge = styled(Box)<StyledBadge>(
  ({ theme }) => ({
    display: 'inline-flex',
    borderRadius: theme.radii.full,
    fontFamily: theme.fontFamily,
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    alignItems: 'center',
    gap: 2,
  }),

  variant<ColorProps, BadgeVariant>({
    variants: {
      primary: {
        color: 'bg',
        bg: 'primary.500',
      },
      secondary: {
        color: 'primary.600',
        bg: 'primary.100',
      },
      tertiary: {
        color: 'neutral.700',
        bg: 'neutral.200',
      },
      warning: {
        color: 'neutral.800',
        bg: 'warning.300',
      },
      error: {
        color: 'error.700',
        bg: 'error.100',
      },
      success: {
        color: 'success.700',
        bg: 'success.100',
      },
      notification: {
        color: 'bg',
        bg: 'red.600',
      },
    },
  }),

  variant<TypographyProps & LineHeightProps & LayoutProps & PaddingProps, BadgeSize>({
    prop: 'size',
    variants: {
      small: {
        height: '16px',
        fontSize: 'small',
        lineHeight: 'small',
        px: 6,
      },

      large: {
        height: '20px',
        fontSize: 'body',
        lineHeight: 'body',
        px: 8,
      },

      huge: {
        height: '28px',
        fontSize: 'body',
        lineHeight: 'body',
        px: 8,
      },
    },
  }),
);
